import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "gota-kanal-route-page-app" }

import SiteHeader from "@shared/Layout/SiteHeader/SiteHeader.vue";
import RoutePage from "./RoutePage.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoutePageApp',
  setup(__props) {

const routePage: RoutePagePayload = window.__litium?.routePage ?? {
  guid: "",
  price: "",
  title: "",
  introduction: "",
  imageUrl: "",
  imageSrcSet: "",
  imageSizes: "",
  imageAltText: "",
  productSystemId: "",
  ticket: null,
  upperBlocks: [],
  lowerBlocks: [],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SiteHeader),
    _createVNode(RoutePage, { "route-page": _unref(routePage) }, null, 8 /* PROPS */, ["route-page"])
  ]))
}
}

})